var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "vx-card",
    { attrs: { title: _vm.config.name, "title-color": "primary" } },
    [
      _c(
        "div",
        {
          staticClass: "vx-card__header",
          attrs: { slot: "header" },
          slot: "header"
        },
        [
          _c("div", { staticClass: "vx-card__title" }, [
            _c("h4", [_vm._v(_vm._s(_vm.config.name))])
          ]),
          _c(
            "div",
            { staticClass: "vx-card__actions" },
            [
              _vm._t("actions", [
                _c(
                  "div",
                  { staticClass: "vx-card__action-buttons" },
                  [
                    _c("feather-icon", {
                      directives: [
                        {
                          name: "b-tooltip",
                          rawName: "v-b-tooltip",
                          value: "Migrar configuraciones de un nivel",
                          expression: "'Migrar configuraciones de un nivel'"
                        }
                      ],
                      staticClass: "ml-4",
                      attrs: { icon: "ArrowUpRightIcon" },
                      on: {
                        click: function($event) {
                          return _vm.migrateParameter()
                        }
                      }
                    })
                  ],
                  1
                )
              ])
            ],
            2
          )
        ]
      ),
      _vm._l(_vm.config.extra.parameters, function(parameter, index) {
        return _c(
          "app-collapse",
          {
            key: index,
            staticClass: "mt-2",
            attrs: { id: "faq-payment-qna", type: "margin" }
          },
          [
            _c("ConfigListItem", {
              key: index,
              attrs: {
                application: _vm.application,
                "selected-user-id": _vm.selectedUserId,
                configurations: _vm.configurations,
                param: parameter
              }
            })
          ],
          1
        )
      }),
      _c(
        "b-modal",
        {
          ref: "migration",
          attrs: {
            id: "migration-modal",
            title: "Migrar",
            "hide-footer": "",
            "no-close-on-backdrop": ""
          }
        },
        [
          _c("div", { staticClass: "row mb-5" }, [
            _c(
              "div",
              { staticClass: "col-md-12 mt-3" },
              [
                _c("label", [_vm._v("Ambiente destino")]),
                _c("v-select", {
                  attrs: {
                    multiple: "",
                    label: "title",
                    options: _vm.ambientsOptions
                  },
                  model: {
                    value: _vm.selectedAmbients,
                    callback: function($$v) {
                      _vm.selectedAmbients = $$v
                    },
                    expression: "selectedAmbients"
                  }
                })
              ],
              1
            ),
            _c(
              "div",
              { staticClass: "col-md-12 mt-3" },
              [
                _c("label", [_vm._v("Niveles")]),
                _c("v-select", {
                  attrs: { label: "id", options: _vm.levels },
                  scopedSlots: _vm._u([
                    {
                      key: "option",
                      fn: function(ref) {
                        var id = ref.id
                        return [
                          _c("span", [
                            _vm._v(" " + _vm._s(_vm._f("capitalize")(id)))
                          ])
                        ]
                      }
                    }
                  ]),
                  model: {
                    value: _vm.selectedLevels,
                    callback: function($$v) {
                      _vm.selectedLevels = $$v
                    },
                    expression: "selectedLevels"
                  }
                })
              ],
              1
            ),
            _c("div", { staticClass: "col-md-12 mt-3" }, [
              _c(
                "div",
                { staticStyle: { float: "right" } },
                [
                  _vm.sendingMigration
                    ? _c("b-spinner", {
                        staticClass: "mr-1",
                        attrs: { variant: "primary" }
                      })
                    : _vm._e(),
                  !_vm.sendingMigration
                    ? _c(
                        "vs-button",
                        {
                          staticClass: "action",
                          attrs: {
                            color: "primary",
                            type: "border",
                            icon: "save"
                          },
                          on: { click: _vm.sendMigrateParameter }
                        },
                        [_vm._v(" Migrar ")]
                      )
                    : _vm._e()
                ],
                1
              )
            ])
          ])
        ]
      )
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }